import React, { createContext, useContext, useState, useEffect } from 'react';
import { adminService } from '../services/adminService';
import { useAuth } from './auth';
import { toast } from 'react-hot-toast';

const AdminContext = createContext({
  isSuperAdmin: false,
  loading: true,
  error: null,
  checkAdminStatus: () => {}
});

export const AdminProvider = ({ children }) => {
  const { user, signed } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const checkAdminStatus = async (force = false) => {
    if (!signed || !user?.id) {
      setIsSuperAdmin(false);
      setLoading(false);
      return false;
    }
    
    try {
      setLoading(true);
      setError(null);
      
      // Verificar se o ID do usuário está no localStorage como superadmin (cache)
      const cachedAdminId = localStorage.getItem('superAdminId');
      
      // Se não forçar verificação e temos cache e o ID bate
      if (!force && cachedAdminId && cachedAdminId === user.id) {
        setIsSuperAdmin(true);
        setLoading(false);
        return true;
      }
      
      // Verifica se o usuário é super-admin com a API
      const isAdmin = await adminService.checkSuperAdmin();
      setIsSuperAdmin(isAdmin);
      
      // Salvar no localStorage para futura referência rápida
      if (isAdmin) {
        localStorage.setItem('superAdminId', user.id);
      } else {
        localStorage.removeItem('superAdminId');
      }
      
      return isAdmin;
    } catch (err) {
      console.error('Erro ao verificar permissões de admin:', err);
      setError('Não foi possível verificar as permissões de administrador');
      setIsSuperAdmin(false);
      return false;
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    checkAdminStatus();
  }, [signed, user?.id]);
  
  return (
    <AdminContext.Provider
      value={{
        isSuperAdmin,
        loading,
        error,
        checkAdminStatus
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin deve ser usado dentro de um AdminProvider');
  }
  return context;
};
